import { environment } from '@environments/environment';
import { ElasticSearchQueryInput } from '@services/elastic-search/models';

export const GET_GENERAL_PROMOTION_QUERY: ElasticSearchQueryInput = {
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_promotions ?? '',
  body: {
    size: 1,
    query: {
      bool: {
        filter: [
          {
            term: {
              status: true,
            },
          },
        ],
      },
    },
    _source: ['promotion'],
  },
};
